import Setting from "setting";
import BaseApi from "./BaseApi";

class FileApi extends BaseApi {
  getUploadProps({
    directory_id,
    object_type,
    object_id,
    origin,
    user_id,
    token,
  }: {
    directory_id: number;
    object_type: number;
    object_id: number;
    origin: string;
    user_id: number | undefined;
    token: string | null;
  }): Object {
    const actionUrl =
      token === null
        ? Setting.REACT_APP_BASE_URL + "/files/public/addpublic"
        : Setting.REACT_APP_BASE_URL + "/files";
    return {
      action: actionUrl,
      data: {
        company_id: 10308,
        creator_id: user_id ? user_id : "",
        directory_id: directory_id,
        is_directory: 0,
        status: 1,
        object_type: object_type,
        object_id: object_id,
        origin: origin,
      },
      headers: {
        "X-Requested-With": null,
        Authorization: token,
      },
      name: "file",
    };
  }
}
export default FileApi;
